(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-key-ingredients"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const initProductKeyIngredients = (container) => {
      if (!container || container.dataset.ingredientsInitialized === 'true') return;
      const triggers = container.querySelectorAll('[data-ingredient-trigger]');
      const panels = container.querySelectorAll('[data-ingredient-panel]');
      const images = container.querySelectorAll('[data-ingredient-image]');
      if (!triggers.length || (!panels.length && !images.length)) return;

      const activatePanel = (target) => {
        triggers.forEach((trigger) => {
          const isActive = trigger.dataset.ingredientTrigger === target;
          trigger.classList.toggle('is-active', isActive);
          trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
          trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
          trigger.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        panels.forEach((panel) => {
          const isMatch = panel.dataset.ingredientPanel === target;
          panel.classList.toggle('is-active', isMatch);
          panel.setAttribute('aria-hidden', isMatch ? 'false' : 'true');
          if (isMatch) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', 'hidden');
          }
        });

        images.forEach((image) => {
          const isMatch = image.dataset.ingredientImage === target;
          image.classList.toggle('is-active', isMatch);
          if (isMatch) {
            image.removeAttribute('hidden');
          } else {
            image.setAttribute('hidden', 'hidden');
          }
        });
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          activatePanel(trigger.dataset.ingredientTrigger);
        });
      });

      container.dataset.ingredientsInitialized = 'true';
    };

    const initAll = () => {
      document.querySelectorAll('[data-product-key-ingredients]').forEach(initProductKeyIngredients);
    };

    document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[data-product-key-ingredients]');
      if (section) initProductKeyIngredients(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
